import { render, staticRenderFns } from "./SiAnnouncementBar.vue?vue&type=template&id=a82acd34&"
import script from "./SiAnnouncementBar.vue?vue&type=script&lang=js&"
export * from "./SiAnnouncementBar.vue?vue&type=script&lang=js&"
import style0 from "./SiAnnouncementBar.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAppBar,VBtn,VFlex,VIcon,VScrollYTransition})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
